import { render, staticRenderFns } from "./settlementTask.vue?vue&type=template&id=71fe7072&scoped=true&"
import script from "./settlementTask.vue?vue&type=script&lang=js&"
export * from "./settlementTask.vue?vue&type=script&lang=js&"
import style0 from "./settlementTask.vue?vue&type=style&index=0&id=71fe7072&prod&lang=scss&scoped=true&"
import style1 from "./settlementTask.vue?vue&type=style&index=1&id=71fe7072&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fe7072",
  null
  
)

export default component.exports